import React from "react";
import { useNavigate } from "react-router-dom";
import "./BackButton.css";

interface BackButtonProps {
  returnToHome?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({ returnToHome = false }) => {
  const navigate = useNavigate();

  const getButtonText = () => {
    return "Retour";
  };

  const handleClick = () => {
    if (returnToHome) {
      navigate("/");
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="GoBackBtn" onClick={handleClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="19.106"
        viewBox="0 0 20 19.106"
      >
        <g
          id="Groupe_59"
          data-name="Groupe 59"
          transform="translate(-19.505 -169.894)"
        >
          <line
            id="Ligne_3"
            data-name="Ligne 3"
            x2="15"
            transform="translate(20.401 178.5)"
            fill="none"
            stroke="#ff5e11"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            id="Tracé_17"
            data-name="Tracé 17"
            d="M2423.263,6120.583l-5.066,8.086,5.066,7.766"
            transform="translate(-2398.099 -5950)"
            fill="none"
            stroke="#ff5e11"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </svg>
      <p className="GoBackBtnTxt">{getButtonText()}</p>
    </div>
  );
};

export default BackButton;
